/* eslint-disable import/no-cycle */
import {observer} from 'mobx-react-lite';
import Descriptions from './Descriptions';
import Spinner from '../spinners/Spinner';
import Label from '../dataDisplay/Label';
import Empty from '../empty/Empty';

const ModelProperties = ({
  column = 1,
  loading,
  properties,
  model,
  title,
  showPropertyLabels = true,
  hideEmpty = false,
  itemLabelStyle,
  ...props
}) => {
  if (loading) {
    return <Spinner fullWidth/>;
  }

  if (!properties || !properties.length || !model) {
    return <Empty/>;
  }

  if (hideEmpty) {
    properties = properties.filter((property) => !!property.render(model, model).children);
  }

  return (
    <Descriptions column={column} title={title} {...props} bordered={!!properties.length}>
      {properties.map((property) => (
        <Descriptions.Item
          key={property.key}
          label={showPropertyLabels ? <Label style={itemLabelStyle}>{property.title}</Label> : undefined}
        >
          {property.render(model, model).children}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
};

export default observer(ModelProperties);
